import { withInstall } from '@lit-element/utils'

import Icon from './src/icon.vue'
import type { SFCWithInstall } from '@lit-element/utils'

export const LtIcon: SFCWithInstall<typeof Icon> = withInstall(Icon)
export default LtIcon

export * from './src/icon'
